import { useCallback } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

export function useStoryNavigate() {
    const navigate = useNavigate()
    const location = useLocation()

    const handleCloseClick = useCallback(() => {
        const backgroundPath = (location.state)?.backgroundPath
        navigate(backgroundPath || '/')
    }, [location.state, navigate])

    const handleSettingsClick = useCallback(() => {
        navigate('/settings/general/story-settings')
    }, [navigate])

    return { handleCloseClick, handleSettingsClick }
}